const TURNSTILE_READY_EVENT = 'turnstile-ready'
const TURNSTILE_READY_TIMEOUT = 15000

function waitForTurnstile () {
  return new Promise((resolve, reject) => {
    if (window.turnstileReady && window.turnstile) {
      resolve()
      return
    }

    const timer = setTimeout(() => {
      window.removeEventListener(TURNSTILE_READY_EVENT, onReady)
      reject(new Error('Turnstile did not become ready in time'))
    }, TURNSTILE_READY_TIMEOUT)

    function onReady () {
      clearTimeout(timer)
      window.removeEventListener(TURNSTILE_READY_EVENT, onReady)
      resolve()
    }

    window.addEventListener(TURNSTILE_READY_EVENT, onReady)
  })
}

export default {
  data () {
    return {
      turnstileError: false,
      turnstileWidgetId: null
    }
  },
  methods: {
    async renderTurnstile (container, sitekey, onToken) {
      this.turnstileError = false

      try {
        await waitForTurnstile()

        this.turnstileWidgetId = window.turnstile.render(container, {
          sitekey: sitekey,
          callback: onToken,
          'error-callback': () => {
            this.turnstileError = true
          },
          'expired-callback': () => {
            this.resetTurnstile()
          }
        })
      } catch (e) {
        this.turnstileError = true
      }
    },
    resetTurnstile () {
      if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.reset(this.turnstileWidgetId)
      }
    }
  }
}
